module.exports = __webpack_public_path__ + "public/img/11.813f2aee.png";